import { Accordion } from '../../../../../components/general/accordion';
import { PqrNotificationClientProps } from '../../form/notificationClient/props';
import { PqrNotificationClient as Component } from '../../form/notificationClient';
import AccessibilityNewIcon from '@mui/icons-material/AccessibilityNew';

export const PqrNotificationClient = (props: PqrNotificationClientProps) => {
    return (
        <Accordion
            title="Notificación cliente"
            defaultExpanded={false}
            icon={<AccessibilityNewIcon />}
            mt="20px"
            padding="0 0 10px"
        >
            <Component {...props} showTitle={false} />
        </Accordion>
    );
};
